import * as ResizablePrimitive from 'react-resizable-panels';
import { cn } from '@/lib/utils';

// v4: PanelGroup → Group (forwardRef dropped; use groupRef/elementRef props if needed)
const ResizablePanelGroup = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof ResizablePrimitive.Group>) => (
  <ResizablePrimitive.Group className={cn('flex h-full w-full', className)} {...props} />
);

ResizablePanelGroup.displayName = 'ResizablePanelGroup';

const ResizablePanel = ResizablePrimitive.Panel;

// v4: PanelResizeHandle → Separator
// aria-orientation describes the SEPARATOR itself, perpendicular to the group axis:
// horizontal (row) group → separator aria-orientation="vertical" (the default styles below),
// vertical (stacked) group → separator aria-orientation="horizontal" (full-width variants).
// Hover/drag state: data-[resize-handle-state=hover|drag] → data-[separator=hover|active]
const ResizableHandle = ({
  withHandle,
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.Separator> & {
  withHandle?: boolean;
}) => (
  <ResizablePrimitive.Separator
    className={cn(
      'group relative flex w-px items-center justify-center duration-150 after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-hidden focus-visible:bg-highlight-base aria-[orientation=horizontal]:h-px aria-[orientation=horizontal]:w-full data-[separator=active]:bg-highlight-base data-[separator=hover]:bg-highlight-base aria-[orientation=horizontal]:after:left-0 aria-[orientation=horizontal]:after:h-1 aria-[orientation=horizontal]:after:w-full aria-[orientation=horizontal]:after:-translate-y-1/2 aria-[orientation=horizontal]:after:translate-x-0 [&[aria-orientation=horizontal]>div]:rotate-90',
      className,
    )}
    {...props}
  >
    {withHandle && (
      <div className="absolute z-10 flex h-7 w-1 items-center justify-center rounded-xs bg-neutral-500 opacity-0 duration-150 group-data-[separator=active]:opacity-100 group-data-[separator=hover]:opacity-100 dark:border-neutral-800 dark:bg-neutral-500" />
    )}
  </ResizablePrimitive.Separator>
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
